module.exports = __webpack_public_path__ + "img/img_assistant_phone_banner.ef4fe0fd.png";